module.exports = "<div class=\"configuration-page\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"panel panel-default blnd-panel\">\n                <div class=\"panel-body\">\n                    <blnd-activity object=\"vm.object\"></blnd-activity>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/product_conf/templates/logs.html
// module id = 767
// module chunks = 0